/** Can be used to assign/reassign Chakra size values */
export const sizes: Record<number, string> = Array.from(Array(100)).reduce(
  (result, _value, index) => ({ ...result, [index + 1]: `${(index + 1) / 4}rem` }),
  {}
);
